"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.classes = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var tf = _interopRequireWildcard(require("@tensorflow/tfjs"));
var _floor2 = _interopRequireDefault(require("lodash/floor"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _sum2 = _interopRequireDefault(require("lodash/sum"));
var _mean2 = _interopRequireDefault(require("lodash/mean"));
var _toNumber2 = _interopRequireDefault(require("lodash/toNumber"));
var _isNaN2 = _interopRequireDefault(require("lodash/isNaN"));
var _LearningBase2 = _interopRequireDefault(require("./LearningBase"));
var _mlCart = require("ml-cart");
var _Utils = _interopRequireDefault(require("./Utils"));
var _Chart = _interopRequireDefault(require("./Chart"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
var classes = exports.classes = ['ai_learning_train', 'ai_learning_decisiontree', 'decisiontree_attr_1', 'decisiontree_attr_2', 'decisiontree_attr_3', 'decisiontree_attr_4', 'decisiontree_attr_5', 'decisiontree_attr_6'];
var DecisionTree = /*#__PURE__*/function (_LearningBase) {
  function DecisionTree() {
    var _this;
    (0, _classCallCheck2["default"])(this, DecisionTree);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DecisionTree, [].concat(args));
    (0, _defineProperty2["default"])(_this, "type", 'decisiontree');
    return _this;
  }
  (0, _inherits2["default"])(DecisionTree, _LearningBase);
  return (0, _createClass2["default"])(DecisionTree, [{
    key: "init",
    value: function init(_ref) {
      var _this2 = this,
        _table$select,
        _table$select2,
        _table$select3;
      var name = _ref.name,
        url = _ref.url,
        result = _ref.result,
        table = _ref.table,
        trainParam = _ref.trainParam,
        modelId = _ref.modelId,
        loadModel = _ref.loadModel;
      this.name = name;
      this.trainParam = trainParam;
      this.result = result;
      this.table = table;
      this.loadModel = loadModel;
      this.trainCallback = function (value) {
        _this2.view.setValue(value);
      };
      this.trained = true;
      this.attrLength = (table === null || table === void 0 || (_table$select = table.select) === null || _table$select === void 0 || (_table$select = _table$select[0]) === null || _table$select === void 0 ? void 0 : _table$select.length) || 0;
      this.fields = table === null || table === void 0 || (_table$select2 = table.select) === null || _table$select2 === void 0 || (_table$select2 = _table$select2[0]) === null || _table$select2 === void 0 ? void 0 : _table$select2.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      });
      this.predictFields = table === null || table === void 0 || (_table$select3 = table.select) === null || _table$select3 === void 0 || (_table$select3 = _table$select3[1]) === null || _table$select3 === void 0 ? void 0 : _table$select3.map(function (index) {
        return table === null || table === void 0 ? void 0 : table.fields[index];
      });
      if (this.url !== url || this.modelId !== modelId) {
        this.load(url, modelId);
        this.url = url;
        this.modelId = modelId;
      }
      if (!_Utils["default"].isWebGlSupport()) {
        tf.setBackend('cpu');
      }
    }
  }, {
    key: "generateTree",
    value: function generateTree() {
      var _this$result = this.result,
        graphData = _this$result.graphData,
        fields = _this$result.fields,
        valueMap = _this$result.valueMap;
      this.tree = new _Chart["default"]({
        source: {
          graphData: graphData,
          fields: fields,
          valueMap: valueMap
        },
        title: Lang.AiLearning.tree_title
      }, 'tree');
    }
  }, {
    key: "openChart",
    value: function openChart() {
      if (!this.tree) {
        this.generateTree();
      } else {
        this.tree.show();
      }
    }
  }, {
    key: "closeChart",
    value: function closeChart() {
      var _this$tree;
      (_this$tree = this.tree) === null || _this$tree === void 0 || _this$tree.hide();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.tree) {
        this.tree.destroy();
        this.tree = null;
      }
      _superPropGet(DecisionTree, "destroy", this, 3)([]);
    }
  }, {
    key: "train",
    value: function () {
      var _train = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this$model;
        var _this$trainParam, _this$trainParam$test, testRate, _this$trainParam$maxD, maxDepth, _this$trainParam$minN, minNumSamples, _this$trainParam$epoc, epochs, _this$trainParam$batc, batchSize, _getData, trainX, trainY, testArr, select, fields, valueMap, numClass, _evaluate, confusionMatrix, score, accuracy, f1, precision, recall;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setTable();
              this.trained = false;
              if (this.tree) {
                this.tree.destroy();
                this.tree = null;
              }
              this.trainCallback(1);
              _this$trainParam = this.trainParam, _this$trainParam$test = _this$trainParam.testRate, testRate = _this$trainParam$test === void 0 ? 0.2 : _this$trainParam$test, _this$trainParam$maxD = _this$trainParam.maxDepth, maxDepth = _this$trainParam$maxD === void 0 ? 3 : _this$trainParam$maxD, _this$trainParam$minN = _this$trainParam.minNumSamples, minNumSamples = _this$trainParam$minN === void 0 ? 3 : _this$trainParam$minN, _this$trainParam$epoc = _this$trainParam.epochs, epochs = _this$trainParam$epoc === void 0 ? 1 : _this$trainParam$epoc, _this$trainParam$batc = _this$trainParam.batchSize, batchSize = _this$trainParam$batc === void 0 ? 1 : _this$trainParam$batc;
              _getData = getData(testRate, this.table), trainX = _getData.trainX, trainY = _getData.trainY, testArr = _getData.testArr, select = _getData.select, fields = _getData.fields, valueMap = _getData.valueMap, numClass = _getData.numClass;
              this.valueMap = Object.fromEntries(Object.entries(valueMap).map(function (_ref2) {
                var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
                  key = _ref3[0],
                  value = _ref3[1];
                return [value, key];
              }));
              this.model = createModel(maxDepth, minNumSamples);
              (_this$model = this.model) === null || _this$model === void 0 || _this$model.train(trainX, trainY);
              _evaluate = evaluate(this.model, testArr, numClass), confusionMatrix = _evaluate.confusionMatrix, score = _evaluate.score;
              this.trained = true;
              this.trainCallback(100);
              accuracy = score.accuracy, f1 = score.f1, precision = score.precision, recall = score.recall;
              this.result = {
                graphData: this.model.toJSON().root,
                select: select,
                fields: fields,
                confusionMatrix: confusionMatrix,
                accuracy: accuracy,
                f1: f1,
                valueMap: this.valueMap,
                precision: precision,
                recall: recall
              };
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function train() {
        return _train.apply(this, arguments);
      }
      return train;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(url, modelId) {
        var _this$model2;
        var data, model, result;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return this.loadModel({
                url: url,
                modelId: modelId
              });
            case 1:
              data = _context2.sent;
              if (data) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              model = data.model, result = data.result;
              this.model = _mlCart.DecisionTreeClassifier.load(model);
              this.valueMap = result === null || result === void 0 ? void 0 : result.valueMap;
              this.result = _objectSpread(_objectSpread({}, result), {}, {
                graphData: (_this$model2 = this.model) === null || _this$model2 === void 0 ? void 0 : _this$model2.toJSON().root
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function load(_x, _x2) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "predict",
    value: function () {
      var _predict = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(array) {
        var _this3 = this;
        var xs, preds;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.model) {
                _context3.next = 1;
                break;
              }
              throw new Error("can't predict: no model");
            case 1:
              xs = [array];
              preds = this.model.predict(xs);
              this.predictResult = preds.map(function (target) {
                return {
                  className: _this3.valueMap[target + 1],
                  probability: 1
                };
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function predict(_x3) {
        return _predict.apply(this, arguments);
      }
      return predict;
    }()
  }]);
}(_LearningBase2["default"]);
var _default = exports["default"] = DecisionTree;
function createModel(maxDepth, minNumSamples) {
  return new _mlCart.DecisionTreeClassifier({
    gainFunction: 'gini',
    // 'gini' Only
    maxDepth: maxDepth,
    minNumSamples: minNumSamples
  });
}
function getData() {
  var testRate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;
  var data = arguments.length > 1 ? arguments[1] : undefined;
  var tempMap = {};
  var tempMapCount = {};
  var _data$select = data.select,
    select = _data$select === void 0 ? [[0], [1]] : _data$select,
    table = data.data,
    fields = data.fields;
  var _select = (0, _slicedToArray2["default"])(select, 2),
    attr = _select[0],
    predict = _select[1];
  var filtered = table.filter(function (row) {
    return !select[0].some(function (selected) {
      return (0, _isNaN2["default"])((0, _toNumber2["default"])(row[selected]));
    });
  });
  var dataArray = filtered.map(function (row) {
    return {
      x: attr.map(function (i) {
        return parseFloat(row[i]) || 0;
      }),
      y: _Utils["default"].stringToNumber(predict[0], row[predict[0]], tempMap, tempMapCount)
    };
  }).map(function (row) {
    return {
      x: row.x,
      y: row.y - 1
    };
  });
  var _sliceArray = sliceArray(dataArray, testRate),
    _sliceArray2 = (0, _slicedToArray2["default"])(_sliceArray, 2),
    train = _sliceArray2[0],
    test = _sliceArray2[1];
  return {
    trainX: train.map(function (v) {
      return v.x;
    }),
    trainY: train.map(function (v) {
      return v.y;
    }),
    testArr: test,
    select: select,
    fields: fields,
    valueMap: _objectSpread({}, tempMap[predict[0]]),
    numClass: tempMapCount[predict[0]] || 1
  };
}
function sliceArray(dataArray, testRate) {
  _Utils["default"].shuffle(dataArray);
  var testNum = Math.floor(dataArray.length * testRate);
  var testArr = dataArray.slice(0, testNum);
  var trainArr = dataArray.slice(testNum, dataArray.length);
  return [trainArr, testArr];
}
function evaluate(model) {
  var validateData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [{
    x: 0,
    y: 0
  }];
  var numClass = arguments.length > 2 ? arguments[2] : undefined;
  var xs = validateData.map(function (data) {
    return data.x;
  });
  var ys = validateData.map(function (data) {
    return data.y;
  });
  var predictYs = model.predict(xs);
  var length = predictYs.length;
  // Confusion Matrix 생성
  var confusionMatrix = Array(numClass).fill(0).map(function () {
    return Array(numClass).fill(0);
  });
  for (var idx = 0; idx < length; idx++) {
    confusionMatrix[ys[idx]][predictYs[idx]]++;
  }
  var score = _Utils["default"].getScores(confusionMatrix, numClass);
  return {
    confusionMatrix: confusionMatrix,
    score: score
  };
}